/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_EyebrowInputs */

const en_blog_eyebrow = /** @type {(inputs: Blog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI journal`)
};

const zh_blog_eyebrow = /** @type {(inputs: Blog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 刊物`)
};

/**
* | output |
* | --- |
* | "Seek AI journal" |
*
* @param {Blog_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_eyebrow = /** @type {((inputs?: Blog_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_eyebrow(inputs)
	return zh_blog_eyebrow(inputs)
});
export { blog_eyebrow as "blog.eyebrow" }